import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {YouthPlayer} from "@/modules/youth/entity";
import {Team} from "@/modules/team/entity";
import {BeforeYouthPlayerRecruitmentEvent} from "@/modules/youth/event/BeforeYouthPlayerRecruitmentEvent";
import {AfterYouthPlayerRecruitmentEvent} from "@/modules/youth/event/AfterYouthPlayerRecruitmentEvent";

@injectable()
export class Recruiter {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
  ) {}

  public async canRecruit(team: Team) {
    return await this.getSlots(team) > await this.getUsedSlots(team);
  }

  public async getSlots(team: Team) {
    return await Promise.resolve(10); // todo
  }

  public async getUsedSlots(team: Team) {
    await team.load('recruitedYouthPlayers');

    return team.recruitedYouthPlayers.length;
  }

  public async recruit(player: YouthPlayer, team: Team) {
    await this.em.emitAsync(new BeforeYouthPlayerRecruitmentEvent(player));

    player.recruitedBy = team;
    await player.save();

    console.debug('recruit youth player', {team, player});

    await this.em.emitAsync(new AfterYouthPlayerRecruitmentEvent(player));
  }
}